import {
  definitions,
  paths,
} from "../../common-fetch/generated/orders-model-api";
import { fetchItJson } from "../../common-fetch/miscellaneous/fetchItJson";
import { FetchOutput } from "../../common-fetch/miscellaneous/fetchResult";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";

type Path = paths["/phrases"];
export type Responses = Path["get"]["responses"];

export type FetchPhrasesOutput = FetchOutput<
  Responses["200"]["schema"],
  definitions["ProblemDetails"]
>;

export async function fetchGetPhrases(
  languageId: string,
  country: string
): Promise<FetchPhrasesOutput> {
  const path: keyof paths = "/phrases";

  return fetchItJson<Responses["200"]["schema"], definitions["ProblemDetails"]>(
    "authorization",
    `${getPartnerPathnameClient(
      true
    )}/Market/HostedCart/Orders/v1${path}?languageId=${languageId}&country=${country}`
  ).catch(() => {
    return { tag: "client-error", parsed: { status: 418 } };
  });
}
